export interface Input {
  style: Marko.HTMLAttributes<HTMLDivElement>["style"];
  front: Marko.AttrTag<Marko.Renderable>;
  back: Marko.AttrTag<Marko.Renderable>;
}

<div class="cast-flip-card" style=input.style>
  <div class="cast-flip-card__card">
    <div class="cast-flip-card__card-front">
      <${input.front}/>
    </div>
    <div class="cast-flip-card__card-back">
      <${input.back}/>
    </div>
  </div>
</div>
